<template>
    <b-carousel v-if="banners.length" controls indicators>
        <b-carousel-slide v-for="(banner, index) in banners" :key="index">
            <template #img>
                <Banner :title="banner.title" :description="banner.description" :bg="banner.bg" :icon="banner.icon"
                    :cta="banner.cta" :ctaHref="banner.ctaHref" />
            </template>
        </b-carousel-slide>
    </b-carousel>
</template>

<script>
import { mapGetters } from 'vuex';
import Banner from '@/components/dashboard/Banner.vue';

export default {
    name: 'BannerCarousel',
    components: {
        Banner
    },
    computed: {
        ...mapGetters(['banners'])
    },
    created() {
        this.$store.dispatch('fetchActiveBanners');
    }
}
</script>

<style>
.carousel-control-next {
    width: 50px;
}

.carousel-control-prev {
    width: 50px;
}

.carousel-indicators {
    margin-bottom: -1.5rem;
}

.carousel-indicators li {
    background-color: #747474 !important;
}

.carousel-indicators .active {
    background-color: var(--secondary) !important;
}
</style>
